import axios from 'axios';
import Client from 'getaddress-api';

const api = axios.create({
  baseURL: API_URL,
});

export const fetchActivity = async (id = '') => {
  try {
    const endpoint =
      process.env.NODE_ENV !== 'production'
        ? '../../mockData/listing/todo.json'
        : `/jla/feeds/activities/${id}`;

    const { data } = await api.get(endpoint);

    return data;
  } catch (error) {
    console.error('Fetch activity failed', error);
    throw error;
  }
};

// export const fetchSagepaySessionKey = async () => {
//   try {
//     const { data } = await api.get('/v1/sagepay/session-key');

//     return data;
//   } catch (error) {
//     // eslint-disable-next-line
//     console.log(error);

//     throw error;
//   }
// };

const validateRecaptcha = async (recaptchaToken) => {
  try {
    const response = await api.post('/wp-json/v1/validate-recaptcha/', {
      'g-recaptcha-response': recaptchaToken,
    });
    return response;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const postFormData = async (data, recaptchaToken) => {
  const prod = process.env.NODE_ENV === 'production';

  if (prod) {
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    formData.append('g-recaptcha-response', recaptchaToken);

    try {
      await api.post(`${API_URL}/form-handler`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    } catch (error) {
      // Debug
      if (error.response) {
        console.error('Error response:', {
          data: error.response.data,
          status: error.response.status,
          headers: error.response.headers,
        });
      } else if (error.request) {
        console.error('No response received:', error.request);
      } else {
        console.error('Other error:', error.message);
      }
    }
  }
};

export const findUkAddressesSuggestions = async (address = '') => {
  try {
    const locationApi = new Client(LOCATION_API);
    const { suggestions } = await locationApi.autocomplete(address);
    if (suggestions && suggestions.length > 0) {
      return suggestions;
    } else {
      return [];
    }
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const fetchDetailsFromAddress = async (address) => {
  try {
    const locationApi = new Client(LOCATION_API);

    return await locationApi.get(address.id);
  } catch (error) {
    console.error(error);
  }
};

export const fetchOpeningStatus = async () => {
  try {
    const endpoint =
      process.env.NODE_ENV !== 'production'
        ? '../../mockData/openingStatus.json'
        : '/jla/feeds/opening-status';

    const { data } = await api.get(endpoint);

    return data;
  } catch (error) {
    console.error('Fetch opening status failed', error);
    throw error;
  }
};

export const fetchAccommodation = async (id = '') => {
  try {
    const endpoint =
      process.env.NODE_ENV !== 'production'
        ? '../../mockData/listing/accommodationItems.json'
        : `/jla/feeds/accommodations/${id}`;

    const { data } = await api.get(endpoint);

    return data;
  } catch (error) {
    console.error('Fetch accommodations failed', error);
    throw error;
  }
};

export const fetchPlaces = async (id = '') => {
  try {
    const endpoint =
      process.env.NODE_ENV !== 'production'
        ? '../../mockData/places.json'
        : `/jla/feeds/places/${id}`;

    const { data } = await api.get(endpoint);

    return data;
  } catch (error) {
    console.error('Fetch places failed', error);
    throw error;
  }
};

export const fetchReviews = async (id = '') => {
  try {
    const endpoint =
      process.env.NODE_ENV !== 'production'
        ? '../../mockData/reviews.json'
        : `/jla/feeds/reviews/${id}`;

    const { data } = await api.get(endpoint);

    return data;
  } catch (error) {
    console.error('Fetch reviews failed', error);
    return null;
  }
};

export const fetchCollections = async () => {
  try {
    const endpoint =
      process.env.NODE_ENV !== 'production'
        ? '../../mockData/holiday-finder/collections.json'
        : '/jla/feeds/holiday-finder/collections';

    const { data } = await api.get(endpoint);

    return data;
  } catch (error) {
    console.error('Fetch collections failed', error);
    throw error;
  }
};

export const fetchDestinations = async () => {
  try {
    const endpoint =
      process.env.NODE_ENV !== 'production'
        ? '../../mockData/holiday-finder/destinations.json'
        : '/jla/feeds/holiday-finder/destinations';

    const { data } = await api.get(endpoint);

    return data;
  } catch (error) {
    console.error('Fetch destinations failed', error);
    throw error;
  }
};

export const fetchHolidayDepartures = async (id = '') => {
  try {
    const endpoint =
      process.env.NODE_ENV !== 'production'
        ? '../../mockData/departures.json'
        : `/jla/feeds/departures/${id}`;

    const { data } = await api.get(endpoint);
    // console.log('Holiday departures data:', JSON.stringify(data));
    return data;
  } catch (error) {
    console.error('Fetch holiday departures failed', error);
    throw error;
  }
};

export const fetchHolidayStylesFilters = async () => {
  try {
    const endpoint =
      process.env.NODE_ENV !== 'production'
        ? '../../mockData/holiday-finder/holiday-styles.json'
        : '/jla/feeds/holiday-finder/holiday-styles';

    const { data } = await api.get(endpoint);

    return data;
  } catch (error) {
    console.error('Fetch holiday styles failed', error);
    throw error;
  }
};

export const fetchFormFields = async (context, hol = '') => {
  try {
    let endpoint;

    if (process.env.NODE_ENV === 'production') {
      switch (context) {
        case 'contact':
          endpoint = `/jla/forms/${context}/${hol}`;
          break;
        case 'newsletter':
        case 'brochure':
        case 'design':
          endpoint = `/jla/forms/${context}`;
          break;
      }
    } else {
      endpoint = `../../mockData/forms/${context}.json`;
    }

    const { data } = await api.get(endpoint);

    return data;
  } catch (error) {
    console.error('Fetch form fields failed', error);
    throw error;
  }
};

export const fetchOnlineBooking = async (hol = '') => {
  try {
    let endpoint;

    if (process.env.NODE_ENV === 'production') {
      endpoint = `/jla/online-booking/${hol}`;
    } else {
      endpoint = '../../mockData/online-booking.json';
    }

    const { data } = await api.get(endpoint);

    return data;
  } catch (error) {
    console.error('Fetch online booking failed', error);
    throw error;
  }
};

export const fetchHolidays = async (id = '', holidayStyles) => {
  try {
    let endpoint;

    if (process.env.NODE_ENV !== 'production') {
      endpoint = '../../mockData/listing/holidays.json';
    } else {
      endpoint = holidayStyles
        ? `/jla/feeds/holiday-styles/${id}`
        : `/jla/feeds/holidays/${id}`;
    }

    const { data } = await api.get(endpoint);

    return data;
  } catch (error) {
    console.error('Fetch holidays failed', error);
    throw error;
  }
};

export const fetchHolidayFinder = async (id = '', holidayStyles) => {
  try {
    let endpoint;

    if (process.env.NODE_ENV !== 'production') {
      endpoint = '../../mockData/holiday-finder/clean-holiday-finder.json';
    } else {
      endpoint = '/jla/feeds/holiday-finder/holiday-finder';
    }

    const { data } = await api.get(endpoint);

    return data;
  } catch (error) {
    console.error('Fetch holiday finder failed', error);
    throw error;
  }
};

export const fetchWishlist = async (ids = []) => {
  try {
    // Convert to comma seperated id string
    ids = ids.reduce((previous = '', current, index) => {
      return `${previous}${current}${index + 1 < ids.length ? ',' : ''}`;
    }, '');

    // fetch
    let endpoint =
      process.env.NODE_ENV !== 'production'
        ? '../../mockData/listing/wishlist.json'
        : `/jla/forms/wishlist/${ids}`;

    const { data } = await api.get(endpoint);

    // Fetch wishlist form fields and wishlist intro
    endpoint =
      process.env.NODE_ENV !== 'production'
        ? '../../mockData/wishlist-intro.json'
        : '/jla/forms/wishlist-intro';
    const {
      data: { intro },
    } = await api.get(endpoint);

    endpoint =
      process.env.NODE_ENV !== 'production'
        ? '../../mockData/forms/wishlist-share.json'
        : '/jla/forms/wishlist-share';

    const { data: formFriend } = await api.get(endpoint);

    endpoint =
      process.env.NODE_ENV !== 'production'
        ? '../../mockData/forms/wishlist.json'
        : '/jla/forms/wishlist';

    const { data: formUs } = await api.get(endpoint);

    const form = { formFriend, formUs };

    return { intro, data, form };
  } catch (error) {
    console.error('Fetch wishlist failed', error);

    return { data: [] };
  }
};
